import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import Card from "@material-ui/core/Card"
import CardHeader from "@material-ui/core/CardHeader"
import CardMedia from "@material-ui/core/CardMedia"
import CardContent from "@material-ui/core/CardContent"
import CardActions from "@material-ui/core/CardActions"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import { Divider, Grid, IconButton, Box } from "@material-ui/core"

import { useHistory } from "react-router-dom"

const useStyles = makeStyles((theme) => ({
	root: {
		...theme.typography.body1,
		backgroundColor: theme.palette.common.white,
		padding: "16px 23px",
	},
}))

const ExcelViewer = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const history = useHistory()
	const theme = useTheme()

	return <Box className={classes.root}>ExcelViewer</Box>
}

export default ExcelViewer
